import { render, staticRenderFns } from "./tenantno.vue?vue&type=template&id=b952cc92&"
import script from "./tenantno.vue?vue&type=script&lang=js&"
export * from "./tenantno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports